export default {
    title: 'Byla nalezena nová verze aplikace',
    button: {
        notNow: 'Zeptat se později',
        ignore: 'Ignorovat',
        refresh: 'Aktualizovat aplikaci'
    }
};
